import { Link } from "react-router";
import { t } from "~/app/i18n";
import { getDocsNavigation } from "~/app/lib/docs.server";
import type { Route } from "./+types/docs._index";

export async function loader(_args: Route.LoaderArgs) {
  const { groups } = getDocsNavigation();
  return { groups };
}

export default function DocsIndex({ loaderData }: Route.ComponentProps) {
  const { groups } = loaderData;

  return (
    <div className="max-w-3xl">
      <h1 className="text-3xl font-bold tracking-tight text-gray-900">
        {t("Documentation")}
      </h1>
      <p className="mt-2 text-lg text-gray-500">
        {t("Welcome to the AnyLawyer documentation")}
      </p>

      <p className="mt-8 leading-relaxed text-gray-600">
        {t(
          "AnyLawyer documentation helps you set up and master our AI-powered legal document intelligence platform. AnyLawyer extracts key data, answers document questions with grounded citations, generates summaries and reports, analyzes court transcripts, and surfaces insights with deep search."
        )}
      </p>

      <hr className="my-10 border-gray-200" />

      <div className="grid gap-6 sm:grid-cols-2">
        {groups.map((group) => (
          <div key={group.group}>
            <h2 className="mb-3 text-sm font-semibold uppercase tracking-wider text-gray-400">
              {group.group}
            </h2>
            <ul className="space-y-2">
              {group.pages.map((page) => (
                <li key={page.slug}>
                  <Link
                    to={`/docs/${page.slug}`}
                    className="text-sm text-[#023220] underline-offset-2 hover:underline"
                  >
                    {page.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
